<script lang="ts" setup>
import { ref } from "vue";
import { Modal, ImageCrop } from "@/components";

const props = defineProps({
  imageUrl: {
    type: String,
    required: true
  },
});

const emits = defineEmits(["close", "submit"]);

const cropperElem = ref();

const submit = () => {
  if (!cropperElem.value) {
    return;
  }

  cropperElem.value.submit();
}

const handleCrop = (blob: Blob) => {
  emits("submit", blob);
}
</script>

<template>
  <Modal :active="true" @close="emits('close')" :scrolling="true">
    <template #header>
      {{ $t("profile.imageCrop.title") }}
    </template>

    <template #body>
      <image-crop
      :imageUrl="imageUrl"
      :aspectRatio="1"
      ref="cropperElem"
      @submit="handleCrop"
    />
    </template>

    <template #footer>
      <div class="buttons">
        <button class="button primary" @click="submit">
          {{ $t("submit") }}
        </button>
        <button class="button" @click="emits('close')">
          {{ $t("cancel") }}
        </button>
      </div>
    </template>
  </Modal>
</template>

<style scoped>
.cropper {
  max-width: 100%;
  height: auto;
  margin: 20px 0;
}
</style>